import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type {
  Message,
  SnackbarReducerInterface,
  ToastScope,
  MessageType,
} from './types';

const initialState: SnackbarReducerInterface = {
  messages: [],
  permanentMessage: [],
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    addMessage(state, action: PayloadAction<Message>) {
      state.messages = [...state.messages, action.payload];
    },
    removeMessage(state) {
      state.messages = state.messages.slice(1);
    },
    removeMessageById(state, action: PayloadAction<string>) {
      state.messages = state.messages.filter(
        (message) => message.id !== action.payload,
      );
      state.permanentMessage = state.permanentMessage.filter(
        (message) => message.id !== action.payload,
      );
    },
    removeMessagesByType(state, action: PayloadAction<MessageType>) {
      state.messages = state.messages.filter(
        (message) => message.type !== action.payload,
      );
      state.permanentMessage = state.permanentMessage.filter(
        (message) => message.type !== action.payload,
      );
    },
    removeMessagesByScope(state, action: PayloadAction<ToastScope>) {
      state.messages = state.messages.filter(
        (message) => message.scope !== action.payload,
      );
      state.permanentMessage = state.permanentMessage.filter(
        (message) => message.scope !== action.payload,
      );
    },
    addPermanentMessage(state, action: PayloadAction<Message>) {
      state.permanentMessage = [...state.permanentMessage, action.payload];
    },
    removePermanentMessage(state) {
      state.permanentMessage = state.permanentMessage.slice(1);
    },
  },
});

export const {
  addMessage,
  removeMessage,
  removeMessageById,
  removeMessagesByType,
  removeMessagesByScope,
  addPermanentMessage,
  removePermanentMessage,
} = snackbarSlice.actions;

export const snackbarReducer = snackbarSlice.reducer;
